import $ from 'jquery';
import bootstrap from 'bootstrap';
import Modernizr from './../modernizr.js';

// important for jQuery to work for other scripts!
global.$ = global.jQuery = require('jquery');
global.Popper = require('popper.js').default;

var MobileRead = (function() {
    function isMobileSite() {
        return $('.header__hamburger').is(':visible') || $(window).width() <= 767;
    }

    function setImageAsBackground(thisImage, isBackground){
        // legacy browser support
        // picturefill();

        // fallback to src for browsers without srcset support
        var src = thisImage.prop('currentSrc') || thisImage.prop('src');
        thisImage.css('display', 'none');
        
        // set the background image for the parent
        var $parent = thisImage.parent();
        var windowWidth = $(window).width();
        var windowHeight = $(window).height();
        if(isBackground){
            src += `&ar=${Math.round(windowWidth)}:${Math.round(windowHeight)}`;
        }
        $parent.css('background-image', 'url('+src+')');
    }

    function init() {
        // load imgix background imageables
        var $img = $(".imgix-bg");
        if ($img.length) {
            // triggered whenever an image is loaded, including on resize
            $img.each(function(theImage){
                // add crop faces for Mobile
                // if($(this).hasClass('mobile') && isMobileSite()){
                //     var attributes = JSON.parse($(this).attr('ix-params'));
                //     // attributes['crop'] = "faces";
                //     attributes['h'] = 450;
                //     $(this).attr('ix-params',JSON.stringify(attributes));
                // }

                $(this).on('load', function(){
                    // if this is a mobile only pic and we're on a mobile page
                    if($(this).hasClass('mobile-only')){
                        if(isMobileSite()){
                            setImageAsBackground($(this));
                        }
                    // else if this is a desktop only pic and we're on a desktop page
                    } else if ($(this).hasClass('desktop-only')){
                        if(!isMobileSite()){
                            setImageAsBackground($(this));
                        }
                    // else it's a normal pic
                    } else if ($(this).hasClass('isBackground')){
                        setImageAsBackground($(this), true);
                    } else {
                        setImageAsBackground($(this), false);
                    }
                });
            });
        }
    }
    init();
})();

var NativeBridge = {
    linkClicked: function(handlerName, message) {
        if (window.ReactNativeWebView) {
            var e = JSON.stringify({
                handlerName: handlerName, 
                data: message
            });
            
            window.ReactNativeWebView.postMessage(e);
            return true;
        }

        else if (window.webkit) {
            // iOS 8+
            var handler = window.webkit.messageHandlers[handlerName];
            if (handler) {
                handler.postMessage(message);
                return true;
            }
        }

        else if (window.jsInterface) {
            // Android
            if(handlerName == "navigateTo"){
                window.jsInterface.openTestimony(message.url, message.title, message.shareUrl);
            } else if (handlerName == 'logScreenView') {
                if(window.jsInterface.logScreenView){
                    window.jsInterface.logScreenView(message);
                }
            }
            return true;
        }

        return false;
    }
};

var App = (function(nativeBridge) {

    function linkClickedHandler(e) {
        e.preventDefault();
        if(this.getAttribute('data-testimony-id')){
            var success = nativeBridge.linkClicked('navigateTo', {
                url: this.getAttribute('data-testimony-id'),
                title: this.getAttribute('data-title'),
                shareUrl: this.getAttribute('data-jp-share-url')
            });
        }
        if(this.getAttribute('data-url')){
            var success = nativeBridge.linkClicked('navigateTo', {
                url: this.getAttribute('data-url'),
                title: this.getAttribute('data-title'),
                shareUrl: this.getAttribute('data-jp-share-url')
            });

        }
        if(this.getAttribute('data-cta')){
            var cta = JSON.parse(this.getAttribute('data-cta'));
            var success = nativeBridge.linkClicked('handleCta', cta);
        }
        console.log("Link Clicked");
    }

    function init(testimonyLinks) {
        for (var i = 0; i < testimonyLinks.length; i++) {
            var link = testimonyLinks[i];
            link.addEventListener('click', linkClickedHandler);
        }
        console.log("Initiated");
    }

    return {
        init: init
    }
})(NativeBridge);

// log screen view for app GA
var logScreenView = function logScreenView(screenName) {
    NativeBridge.linkClicked('logScreenView', {
        screenName: screenName
    });
    console.log("Logged", screenName);
}

global.App = App;
global.NativeBridge = NativeBridge;
global.logScreenView = logScreenView;

